/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrendingNotificationActionData } from './TrendingNotificationActionData';
import {
    TrendingNotificationActionDataFromJSON,
    TrendingNotificationActionDataFromJSONTyped,
    TrendingNotificationActionDataToJSON,
} from './TrendingNotificationActionData';

/**
 * 
 * @export
 * @interface TrendingNotificationAction
 */
export interface TrendingNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof TrendingNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof TrendingNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof TrendingNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {TrendingNotificationActionData}
     * @memberof TrendingNotificationAction
     */
    data: TrendingNotificationActionData;
}

/**
 * Check if a given object implements the TrendingNotificationAction interface.
 */
export function instanceOfTrendingNotificationAction(value: object): value is TrendingNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function TrendingNotificationActionFromJSON(json: any): TrendingNotificationAction {
    return TrendingNotificationActionFromJSONTyped(json, false);
}

export function TrendingNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrendingNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': TrendingNotificationActionDataFromJSON(json['data']),
    };
}

export function TrendingNotificationActionToJSON(value?: TrendingNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': TrendingNotificationActionDataToJSON(value.data),
    };
}

